import React from "react";

import PropTypes from "prop-types";
import { Col, Row, VertTypography } from "@vertem-core/vertice-ds";

const { Title, Text } = VertTypography;

const TitleForm = ({ icon, title, subtitle }) => {
  return (
    <Row gutter={0}>
      <div className="icon-participant">{icon}</div>
      <Title>{title}</Title>
      <Text>{subtitle}</Text>
    </Row>
  );
};

export default TitleForm;

TitleForm.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};
